import React, { useState, useCallback, useEffect } from "react";

const Value = ({ img, title, subtitle, children, numVals, link, ...props }) => (
  <div className={`z-10 md:w-1/${numVals} p-6 lg:p-12 text-white`} {...props}>
    <div className="flex flex-row items-center md:flex-col md:items-start">
      <img src={img} className="h-16 w-16 mr-5" alt=""/>
      <div>
        <h2 className="text-xl lg:text-2xl font-bold mt-5">{title}</h2>
        <h2 className="text-xl lg:text-2xl mt-1 mb-4">
          {subtitle}
        </h2>
      </div>
    </div>
    <p className="pb-5 md:pb-0 font-medium">{children}</p>
  </div>
);

const NewValues = ({ vals }) => {
  const [active, setActive] = useState(null);
  const [elts, setElts] = useState([]);
  const [pixelsFromTop, setPixelsFromTop] = useState(0);

  let numVals = vals.length;

  useEffect(() => {
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Windows Phone/i.test(
        navigator.userAgent
      )
    ) {
      console.log("is mobile");
      setActive(1)
    } else {
      setActive(0)
    }
  }, []);

  const ref = useCallback((x) => {
    if (x && x.children) {
      window.valuesElts = x.children;
      setElts(x.children);
    }
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (
        window.valuesElts &&
        window.valuesElts[0].offsetTop != window.valuesElts[1].offsetTop
      ) {
        for (let i = numVals - 1; i >= 0; --i) {
          if (
            Math.abs(
              window.valuesElts[i].getBoundingClientRect().top /
                window.innerHeight
            ) < 0.5
          ) {
            setActive(i);

            let totalPixelsFromTop = 0;
            if (i > 0) {
              for (let j = 0; j <= i - 1; j += 1) {
                totalPixelsFromTop += window.valuesElts[j].clientHeight;
              }
            }
            setPixelsFromTop(totalPixelsFromTop);
              
            break;
          }
        }
      }
    });
  }, []);

  return (
    <div className="text-black pt-10 pb-20">
      <div className="max-w-page px-3">
        <div
          className="flex flex-col md:flex-row relative"
          onMouseOut={() => setActive(0)}
          ref={ref}
        >
          {vals.map(({ img, title, desc, subtitle, link }, i) => (
            <Value
              numVals={numVals}
              active={active}
              current={i}
              key={title}
              img={img}
              title={title}
              subtitle={subtitle}
              link={link}
              onMouseOver={() => setActive(i)}
            >
              {desc}
            </Value>
          ))}

          <div
            className={`hidden md:block z-0 absolute top-0 bottom-0 rounded-lg md:w-1/${numVals} fadeIn`}
            style={{
              left: active * (100 / numVals) + "%",
              transition: "left 0.2s",
              backgroundColor: "#7C8086",
            }}
          />
          {active !== null && (
            <div
              className={`md:hidden z-0 absolute left-0 right-0 rounded-lg md:w-1/${numVals} fadeIn`}
              style={{
                top: pixelsFromTop + "px",
                transition: "top 0.2s",
                backgroundColor: "#7C8086",
                height: (elts[active] || {}).offsetHeight,
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default NewValues;
